import { CalculateAnonymousForecastResponse } from "models";

import { OnboardingForecastPoint, buildOnboardingForecastSeries } from "pages/app/scenario-onboarding/utils/onboardingForecast";

export const buildAnonymousForecastChartSeries = (forecast: CalculateAnonymousForecastResponse): OnboardingForecastPoint[] =>
  buildOnboardingForecastSeries(forecast.baseline.years, forecast.change.years);

// The delta is change minus baseline, so it is negative when the soil-building practices finish behind.
export const getAnonymousForecastCumulativeDelta = (series: OnboardingForecastPoint[]): number => {
  const lastPoint = series[series.length - 1];
  if (!lastPoint || lastPoint.changeCumulative == null) return 0;

  return lastPoint.changeCumulative - lastPoint.baselineCumulative;
};

// Figma shades one side of the crossover only. We keep the years that sit the same way round as year 10.
export const getDeltaHighlightBand = (point: OnboardingForecastPoint, practicesAheadAtEnd: boolean): [number, number] | null => {
  if (point.changeCumulative == null) return null;

  const wrongSideOfCrossover = practicesAheadAtEnd ? point.changeCumulative < point.baselineCumulative : point.changeCumulative > point.baselineCumulative;

  return wrongSideOfCrossover ? null : point.band;
};
